import ReactDOM from "react-dom";
import React from "react";
import { Footer } from "../../shared/footer.js";
import { Navbar } from "../../shared/navbar.js";
import "../../../../shared/styles/colorDefinitions.css";
import "../../style.css";
import "./priceList.css";
import "../../../../shared/styles/linkStyles.css";
import "../../../../shared/styles/buttonStyles.css";
import Main from "./Main.tsx";
function Body() {
    return (React.createElement(React.Fragment, null,
        React.createElement(Navbar, null),
        React.createElement(Main, null),
        React.createElement(Footer, null)));
}
// eslint-disable-next-line react/no-deprecated
ReactDOM.render(Body(), document.body.querySelector("#container"));
